type loaderAvailableNames = 'DEFAULT' | 'UPLOAD' | 'MINIMALIST';
type loaderStepName = 'IMMEDIATE' | 'INDETERMINATE' | 'DEFAULT';

const enum UILoader {
  IMMEDIATE = 'IMMEDIATE',
  INDETERMINATE = 'INDETERMINATE',
  DEFAULT = 'DEFAULT',
  UPLOAD = 'UPLOAD',
  MINIMALIST = 'MINIMALIST',
}

export type { loaderAvailableNames, loaderStepName };

export { UILoader };
